export const dbTabs1 = {
  presentation: {
    descriptionTitle: "وصف الإعلان",
    descriptionSub: "اختر ما إذا كان الوصف يظهر في صفحة الحجز المباشر لكل وحدة.",
    visible: "ظاهر",
    hidden: "مخفي",
    amenitiesTitle: "الخدمات المضمّنة",
    amenitiesSub: "حدّد الخدمات ووسائل الراحة التي ستظهر لكل وحدة في محرك الحجز الخاص بك.",
    amenitiesCount: "{count} خدمة | {count} خدمات",
    editAmenitiesTitle: "تعديل الخدمات",
    edit: "تعديل",
    imagesTitle: "صور مكان الإقامة",
    imagesSubtitle: "قم برفع الصور وترتيبها وتحديد الصورة الرئيسية لكل وحدة التي ستظهر في محرك الحجز الخاص بك.",
  },
  reservations: {
    updating: "جارٍ التحديث…",
    engineActive: "المحرك مُفعّل",
    engineInactive: "المحرك مُعطّل",
    engineActiveDesc: "يمكن للنزلاء حجز الغرف مباشرةً من الرابط الخاص بك.",
    engineInactiveDesc: "الحجوزات المباشرة مُعطّلة لهذا الفندق.",
    statusActive: "مُفعّل",
    statusInactive: "مُعطّل",
    roomsAvailable: "الغرف المتاحة",
    colRoom: "الغرفة",
    colCap: "السعة",
    colActive: "مُفعّلة",
    noRooms: "لا توجد غرف مُهيّأة.",
    hotelLabel: "فندق",
    unitActive: "مُفعّلة",
    unitInactive: "مُعطّلة",
    enableNotice: "فعّل الحجوزات المباشرة لتتمكن من إدارة الغرف.",
    toastUpdated: "تم التحديث.",
    toastUpdateError: "تعذّر التحديث.",
    toastGlobalUpdated: "تم تحديث الحالة العامة.",
  },
  promotions: {
    title: "العروض الترويجية في الحجز المباشر",
    subtitle: "تحكّم في أيّها مُفعّل، وما إذا كانت قابلة للتراكم، وترتيبها.",
    loading: "جارٍ تحميل العروض…",
    empty: "لا توجد عروض مُهيّأة لهذا العقار.",
    dragTitle: "اسحب لإعادة الترتيب",
    switchTitle: "مُفعّل في الحجز المباشر",
    badgeLabel: "شارة",
    badgePlaceholder: "مثال: -10% / عرض",
    stackableLabel: "قابل للتراكم",
    tip: "نصيحة: فعّل العرض لتطبيقه في الحجز المباشر واستخدم ”قابل للتراكم“ إذا كان يمكن أن يتوافق مع عروض أخرى.",
    toastLoadError: "تعذّر تحميل العروض.",
    toastSaved: "تم حفظ العروض بنجاح.",
    toastSaveError: "تعذّر حفظ العروض.",
    dateFrom: "من {date}",
    dateUntil: "حتى {date}",
  },
  addons: {
    title: "الإشغال والرسوم",
    hint1: "تعديل واحد لكل {scope}: تخفيض عند وجود نزلاء أقل",
    hintOr: "أو",
    hint2: "رسوم إضافية لكل نزيل إضافي. وليس كلاهما.",
    perRoom: "غرفة",
    perAccommodation: "مكان إقامة",
    loading: "جارٍ تحميل الإعدادات…",
    emptyHotel: "لا توجد غرف مُهيّأة لهذا الفندق.",
    thisAccommodation: "مكان الإقامة هذا",
    modeReduction: "تخفيض",
    modeSurcharge: "زيادة",
    modeNone: "دون تعديل",
    toastLoadError: "تعذّر تحميل إعدادات الإشغال.",
    toastSaved: "تم حفظ الإشغال بنجاح.",
    toastSaveError: "تعذّر حفظ الإشغال.",
  },
};
